module.exports = __webpack_public_path__ + "static/media/DownGraphIcon.9244f5ac.svg";